import { ApiOutlined, FileSearchOutlined, FileTextOutlined, ShoppingCartOutlined, UnorderedListOutlined } from "@ant-design/icons";
import type { TabsProps } from "antd";
import { Tabs } from "antd";
import { UserRole } from "commons/constants";
import PriceListPage from "pages/ price-list";
import { useState } from "react";
import { useAppSelector } from "store";
import SalesOrder from ".";
import InvoiceNamePage from "../invoice-name";
import IpScalePage from "../ip-scale";
import ReportV2 from "./components/ReportV2";

const defaultTab = [
	{
		label: "Quản lý đơn hàng",
		key: "2",
		children: <SalesOrder />,
		icon: <ShoppingCartOutlined />,
		role: [UserRole.Sale, UserRole.Accountant, UserRole.Staff, UserRole.FarmManager, UserRole.Administrator],
	},
	{
		label: "Quản lý dòng đơn",
		key: "3",
		children: <ReportV2 />,
		icon: <FileSearchOutlined />,
		role: [UserRole.Sale, UserRole.Accountant, UserRole.Staff, UserRole.FarmManager, UserRole.Administrator],
	},
	{
		label: "Quản lý bảng giá",
		key: "1",
		children: <PriceListPage />,
		icon: <UnorderedListOutlined />,
		role: [UserRole.Accountant, UserRole.Administrator],
	},
	{
		label: "Tên xuất hoá đơn",
		key: "4",
		children: <InvoiceNamePage />,
		icon: <FileTextOutlined />,
		role: [UserRole.Accountant, UserRole.Administrator],
	},
	{
		label: "Quản lý IP cân",
		key: "5",
		children: <IpScalePage />,
		icon: <ApiOutlined />,
		role: [UserRole.Accountant],
	},
];

const IndexPage = () => {
	const user = useAppSelector((state) => state.user);
	const [items] = useState<TabsProps["items"]>(() => {
		return defaultTab.filter((item) => item.role.includes(user?.role as UserRole));
	});

	return <Tabs type="card" defaultActiveKey={items?.[0].key} items={items} tabBarStyle={{ marginBottom: 26 }} />;
};

export default IndexPage;
